import script from "./EditCategoryForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditCategoryForm.vue?vue&type=script&lang=ts&setup=true"

import "./EditCategoryForm.vue?vue&type=style&index=0&id=4eccfa4d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eccfa4d"]])

export default __exports__